import { render, staticRenderFns } from "./26huanghuacai.vue?vue&type=template&id=500aeba8&"
import script from "./26huanghuacai.vue?vue&type=script&lang=js&"
export * from "./26huanghuacai.vue?vue&type=script&lang=js&"
import style0 from "./26huanghuacai.vue?vue&type=style&index=0&id=500aeba8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports